<template>
    <div>
        <h1>401</h1>
    </div>
</template>

<script>
export default {
    
}
</script>
<style lang="scss" scoped>

</style>